import React, { createContext, useContext, useState, PropsWithChildren, useMemo } from 'react';

interface ProtectedRouteContextProps {
  isPublic: boolean;
  setIsPublic: (isPublic: boolean) => void;
}

const ProtectedRouteContext = createContext<ProtectedRouteContextProps | undefined>(undefined);

export const ProtectedRouteProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [isPublic, setIsPublic] = useState(false);

  const value = useMemo(() => ({ isPublic, setIsPublic }), [isPublic, setIsPublic]);

  return (
    <ProtectedRouteContext.Provider value={value}>
      {children}
    </ProtectedRouteContext.Provider>
  );
};

export const useProtectedRoute = (): ProtectedRouteContextProps => {
  const context = useContext(ProtectedRouteContext);
  if (!context) {
    throw new Error('useProtectedRoute must be used within a ProtectedRouteProvider');
  }
  return context;
};
